module.exports = __webpack_public_path__ + "4a20d3d2714b5101f1a603890c77d421.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/fake-horse.png
// module id = 1884
// module chunks = 0